<template>
  <span>
    <v-row dense>
      <v-col cols="6" v-for="chart in chartDataComputed" :key="chart.chartRef">
        <v-card-charts-dashboard
          :title="chart.title"
          :chart-ref="chart.chartRef"
          :options="chart.options"
          :deep-copy-on-update="chart.deepCopyOnUpdate"
          :is-loading="chart.loading"
        />
      </v-col>
    </v-row>
  </span>
</template>

<script>
export default {
  name: "DashboardFaturamentoVisaoAneelCardsTipologias",
  components: {
    VCardChartsDashboard: () =>
      import("@/components/base/VCardChartsDashboard.vue"),
  },
  props: {
    dadosTipologiaFaturasSemLeitura: {
      type: Object,
      required: true,
    },
    dadosTipologiaAcertosFaturamento: {
      type: Object,
      required: true,
    },
    exportingOptions: {
      type: Object,
      required: true,
    },
    loading: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    chartTipologiaFaturasSemLeituraOptions: {},
    chartTipologiaAcertosFaturamentoOptions: {},
    chartData: [
      {
        title: "Tipologia das Faturas Sem Leitura",
        chartRef: "dadosTipologiaFaturasSemLeitura",
        optionsProp: "chartTipologiaFaturasSemLeituraOptions",
        deepCopyOnUpdate: false,
      },
      {
        title: "Tipologia dos Acertos de Faturamento",
        chartRef: "dadosTipologiaAcertosFaturamento",
        optionsProp: "chartTipologiaAcertosFaturamentoOptions",
        deepCopyOnUpdate: false,
      },
    ],
  }),
  computed: {
    chartDataComputed() {
      return this.chartData.map((chart) => {
        return {
          ...chart,
          options: this[chart.optionsProp],
          loading: !!this.loading[chart.chartRef],
        };
      });
    },
  },
  mounted() {
    this.setChartOptions();
  },
  methods: {
    setChartOptions() {
      this.setChartTipologiaFaturasSemLeituraOptions();
      this.setChartTipologiaAcertosFaturamentoOptions();
    },
    getDefaultPieChartOptions() {
      return {
        chart: {
          type: "pie",
          height: 300,
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: "pointer",
            dataLabels: {
              enabled: true,
              distance: 30,
              formatter: function() {
                return `${this.point.name}: ${parseFloat(
                  this.point.y,
                ).toLocaleString("pt-BR")}`;
                // return parseFloat(this.point.y).toLocaleString('pt-BR')
              },
            },
            showInLegend: true,
          },
        },
        credits: { enabled: false },
        title: { text: null },
        subtitle: { text: null },
        legend: { enabled: false },
        lang: {
          noData: "Sem dados para exibição",
        },
        series: [
          {
            name: "Valor",
            colorByPoint: true,
            innerSize: "75%",
            animation: false,
            data: [],
          },
        ],
        exporting: this.exportingOptions,
      };
    },
    setChartTipologiaFaturasSemLeituraOptions() {
      let options = this.getDefaultPieChartOptions();

      options.series[0].data = [
        {
          name: "Impedimento de Acesso",
          y: this.dadosTipologiaFaturasSemLeitura.com_009,
        },
        {
          name: "Situação de Emergência",
          y: this.dadosTipologiaFaturasSemLeitura.com_010,
        },
        {
          name: "Leitura Plurimensal",
          y: this.dadosTipologiaFaturasSemLeitura.com_011,
        },
        {
          name: "Aplicação do Art. 228",
          y: this.dadosTipologiaFaturasSemLeitura.com_012,
        },
        {
          name: "Encerramento Contratual",
          y: this.dadosTipologiaFaturasSemLeitura.com_013,
        },
        {
          name: "Ausência Temporária no Sistema",
          y: this.dadosTipologiaFaturasSemLeitura.com_014,
        },
      ];

      this.chartTipologiaFaturasSemLeituraOptions = options;
    },
    setChartTipologiaAcertosFaturamentoOptions() {
      let options = this.getDefaultPieChartOptions();

      options.series[0].data = [
        {
          name: "Faturamento Incorreto",
          y: this.dadosTipologiaAcertosFaturamento.com_017,
        },
        {
          name: "Devolução em Dobro",
          y: this.dadosTipologiaAcertosFaturamento.com_018,
        },
        {
          name: "Devolução Simples (Consumidor)",
          y: this.dadosTipologiaAcertosFaturamento.com_019,
        },
        {
          name: "Devolução Simples (Terceiro)",
          y: this.dadosTipologiaAcertosFaturamento.com_020,
        },
        {
          name: "Impedimento de Acesso",
          y: this.dadosTipologiaAcertosFaturamento.com_021,
        },
        {
          name: "Situação de Emergência",
          y: this.dadosTipologiaAcertosFaturamento.com_022,
        },
        {
          name: "Sem Leitura, Faturamento Médio",
          y: this.dadosTipologiaAcertosFaturamento.com_023,
        },
      ];

      this.chartTipologiaAcertosFaturamentoOptions = options;
    },
  },
  watch: {
    dadosTipologiaFaturasSemLeitura() {
      this.setChartOptions();
    },
    dadosTipologiaAcertosFaturamento() {
      this.setChartOptions();
    },
  },
};
</script>

<style></style>
